import getContentContainerDetails from '@src/quince-site-common/src/utils/getContentContainerDetails'
import CUSTOM_SECTION_CONTAINER_NAMES from '@src/quince-site-common/src/constants/customSectionContainerNames'
import CUSTOM_SECTION_CONTAINER_TYPES from '@src/quince-site-common/src/constants/customSectionContainerTypes'
import { TrackingMetaData } from '@src/quince-site-common/src/domains/CustomSection'

export const TRACKING_METADATA = {
  category: 'navigation',
  action: 'click_product_category_carousel',
}

export const getTrackingLabel = (tracker: string | undefined) => `${tracker}__imageWithProductCarousel_custom_section`

export const getContentContainerTrackingMetadata = (trackingMetaData: TrackingMetaData | undefined) => {
  const contentContainerDetails = getContentContainerDetails(trackingMetaData)

  return {
    contentContainerType:
      contentContainerDetails.contentContainerType || CUSTOM_SECTION_CONTAINER_TYPES.PRODUCT_DISPLAY,
    contentContainerName:
      contentContainerDetails.contentContainerName || CUSTOM_SECTION_CONTAINER_NAMES.SINGLE_SWIMLANE,
    contentContainerDisplayName: contentContainerDetails.contentContainerDisplayName,
  }
}
